import { withStyles } from '@material-ui/core/styles';
import { variant } from '../../../materialConfig/customTypography';
import TableCell from '@material-ui/core/TableCell';

const borderRadius = '4px';
export const BaseTableCell = withStyles((theme) => ({
  head: {
    height: '45px',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.black,
    fontWeight: 500,
    fontSize: '14px',
    border: 'none',
    // '&:first-child': {
    //   borderRadius: `${borderRadius} 0 0 ${borderRadius}`,
    // },
    // '&:last-child': {
    //   borderRadius: `0 ${borderRadius} ${borderRadius} 0`,
    // },
    borderBottom: 'none !important',
  },
  body: {
    ...variant.smallText,
  },
  root: {
    padding: '30px 5px',
    border: 0,
    textAlign: 'center',
    color: '#000000',
    borderBottom: '1px solid #5cccf2',

    [theme.breakpoints.up('sm')]: {
      minWidth: '120px'
    },
  },
}))(TableCell);
